import React from 'react';
import {Button} from "primereact/button";
import {useDispatch, useSelector} from "react-redux";
import {selectView} from "../../redux/slices/kpiSlice";

const views = [
    "Goals, Targets and Benchmarks", "Annual", "All"
]

const ViewSelector = () => {
    const selectedView = useSelector(state => state.kpi.selectedView);
    const dispatch = useDispatch();

    const changeSelectedView = (diff) => dispatch(selectView((selectedView + diff) % views.length));

    return (
        <div className="year-selector">
            <Button type="button" icon="pi pi-chevron-left" onClick={() => changeSelectedView(-1)} />
            <div className="current-year">{views[selectedView]}</div>
            <Button type="button" icon="pi pi-chevron-right" onClick={() => changeSelectedView(1)} />
        </div>
    )
}

export default ViewSelector;